<template>
  <base-modal
    hookSufix="Reset2FAModal"
    content-class="reset-2FA-modal"
    :modalWidth="'600px'"
    :minHeight="'unset'"
    :persistent="false"
    :onCloseHook="onClose"
    :hideCloseBtn="true"
    :disableDefaultPadding="true"
  >
    <template #content>
      <v-row no-gutters>
        <span class="reset-2fa-modal-header--title body-bold-medium">{{
          $t('message.pages.users.twoFactor.reset2faModal.title')
        }}</span>
        <v-spacer></v-spacer>
        <v-icon class="close-btn" @click="closeModal">panda-close</v-icon>
      </v-row>
      <div class="reset-2fa-modal-content">
        <p class="reset-2fa-modal-content--subtitle body-bold-base">
          {{
            $t('message.pages.users.twoFactor.reset2faModal.subtitle', {
              userName: userData.name,
            })
          }}
        </p>
        <p class="description body-regular-small">
          {{ $t('message.pages.users.twoFactor.reset2faModal.description') }}
        </p>
      </div>
      <v-divider></v-divider>
    </template>
    <template #card-actions>
      <div class="footer">
        <v-spacer />
        <base-btn type="tertiary" class="mr-3" depressed @click="cancel">{{
          $t('message.pages.users.twoFactor.reset2faModal.cancelBtn')
        }}</base-btn>
        <base-btn
          type="primary"
          depressed
          @click="confirm"
          :loading="disablingLoading"
          keep-width-on-loading
          >{{
            $t('message.pages.users.twoFactor.reset2faModal.resetBtn')
          }}</base-btn
        >
      </div>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from '@/components/BaseModal.vue'
import BaseBtn from '@/components/BaseBtn.vue'
import twoFactorAuthApi from '@/services/twoFactorAuthApi'
import { mapMutations } from 'vuex'
import i18n from '@/translations/lang'
export default {
  name: 'Reset2FAModal',
  components: {
    BaseModal,
    BaseBtn,
  },
  data: () => ({
    userData: {
      name: '',
    },
    disablingLoading: false,
  }),
  mounted() {
    this.$root.$on('openReset2FAModal', (user) => (this.userData = user))
  },
  methods: {
    ...mapMutations('user', ['UPDATE_USER_ALLINFO', 'UPDATE_GLOBAL_SNACKBAR']),
    async confirm() {
      this.disablingLoading = true
      try {
        await twoFactorAuthApi.mfaDisableByUserId(this.userData.id)
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: i18n.t(
            'message.pages.users.twoFactor.snackBar.resetMfa.success'
          ),
          type: 'success',
        })
        this.$root.$emit('auth2faReseted', this.userData.id)
      } catch (error) {
        console.log(error)
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: i18n.t('message.pages.users.twoFactor.snackBar.resetMfa.fail'),
          type: 'error',
        })
      } finally {
        this.disablingLoading = false
        this.$root.$emit('closeReset2FAModal')
      }
    },
    cancel() {
      this.$root.$emit('closeReset2FAModal')
    },
    openHelp() {
      const link = this.$t('message.pages.users.twoFactor.articleLink')
      window.open(link, '_blank')
    },
    onClose() {
      this.$emit('cancelReset')
    },
    closeModal() {
      this.$root.$emit('closeReset2FAModal')
    },
  },
}
</script>

<style lang="scss" scoped>
.reset-2fa-modal-content {
  display: flex;
  flex-direction: column;
  align-items: start;
  text-align: start;
  padding: $spacing-07;
}

.icon-wrapper {
  padding: $spacing-05;
  margin-left: $spacing-07;
  border-radius: 56px;
  width: 80px;
  &.theme--dark {
    background-color: varFigma(feedback-warning-background);
  }
}

.description {
  color: varFigma(neutral-40-light);
  letter-spacing: 0.05em;
}

.reset-2fa-modal-header--title {
  color: varFigma(neutral-20-dark);
  margin-left: $spacing-07;
}
.reset-2fa-modal-content--subtitle {
  color: varFigma(neutral-20-dark);
}

.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: $spacing-07 $spacing-07 0 $spacing-07;
}

.text-link {
  text-transform: none;
  color: varFigma(brand-60-base) !important;
  padding: 0 !important;
  height: 21px !important;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  &.v-btn::before {
    background-color: transparent;
  }
}

.close-btn {
  width: 24px;
  height: 24px;
  align-items: flex-start;
  margin-right: $spacing-07;
  &.v-icon.v-icon::after {
    background-color: transparent;
  }
}
</style>
<style lang="scss">
.reset-2FA-modal {
  padding: $spacing-07 0;
}
</style>
